export default "__VITE_ASSET__iJSoqN8z__"